var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "view-button-section" }, [
    _c(
      "button",
      {
        staticClass: "button",
        class: { primary: _vm.isAgendaDayViewSelected },
        on: {
          click: function($event) {
            return _vm.view("timeGridDay")
          }
        }
      },
      [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "Day")) + "\n\t")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button",
        class: { primary: _vm.isAgendaWeekViewSelected },
        on: {
          click: function($event) {
            return _vm.view("timeGridWeek")
          }
        }
      },
      [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "Week")) + "\n\t")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button",
        class: { primary: _vm.isMonthViewSelected },
        on: {
          click: function($event) {
            return _vm.view("dayGridMonth")
          }
        }
      },
      [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "Month")) + "\n\t")]
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button",
        class: { primary: _vm.isMonthListViewSelected },
        on: {
          click: function($event) {
            return _vm.view("listMonth")
          }
        }
      },
      [_vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "List")) + "\n\t")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }